import React from 'react'

export default function BetaBadge({text}) {
  return (
    <span className='beta-badge'>{text ?? "BETA"}</span>
  )
}
